import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

type HeadFilterBooleanFieldProps = {
  filterValue: string;
  setFilterValue: (value: string) => void;
  selectedColumn: { label?: string } | null;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function HeadFilterBooleanField({
  filterValue,
  setFilterValue,
  selectedColumn,
  t,
}: HeadFilterBooleanFieldProps) {
  const options = [
    { value: 'true', label: t('YES') },
    { value: 'false', label: t('NO') },
  ];

  return (
    <TextField
      select
      fullWidth
      size="small"
      label={`${t('SELECT')} ${selectedColumn?.label}`}
      value={filterValue}
      onChange={(e) => setFilterValue(e.target.value)}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
